import Cookies from 'js-cookie';
import React from 'react';

class CountryDropdown extends React.Component {
  cookieDomain = () => {
    const domain = '.charitywater.org';
    const {hostname} = window.location;
    return (hostname.indexOf(domain) !== -1) ? domain : hostname;
  };

  handleCountryClick = (country) => {
    Cookies.set('countrypreference', country, { expires: 365, domain: this.cookieDomain() });
    window.location = country == 'UK' ? this.props.ukUrl : this.props.usUrl;
  }

  selectedCurrencyName = () => this.props.currentCountry == 'uk' ? this.props.ukCurrencyName : this.props.usCurrencyName;

  render() {
    return (
      <ul className='nav-buttons'>
        <li className='has-dropdown country-dropdown button-links ml-2 mr-0'>
          <a className={`${this.props.currentCountry} country`} href=''>
            <span>{` ${this.selectedCurrencyName()} `}</span>
            <span className='icn cw-icon-caret-down' />
          </a>
          <ul className='dropdown'>
            <li className='contains-caret donate-caret'>
              <span className='icn cw-icon-caret-up' />
              <span
                className='country-dropdown-option us'
                onClick={() => this.handleCountryClick('US')}
              >
                {this.props.usCurrencyFullName}
              </span>
            </li>
            <li>
              <span
                className='country-dropdown-option uk'
                onClick={() => this.handleCountryClick('UK')}
              >
                {this.props.ukCurrencyFullName}
              </span>
            </li>
          </ul>
        </li>
      </ul>
    );
  }
}

export default CountryDropdown;
